Object.defineProperty(exports, "__esModule", {
  value: true
});

var natura_light_1 = require("./themes/natura/natura-light");

var natura_dark_1 = require("./themes/natura/natura-dark");

var avon_light_1 = require("./themes/avon/avon-light");

var avon_dark_1 = require("./themes/avon/avon-dark");

var the_body_shop_light_1 = require("./themes/theBodyShop/the-body-shop-light");

var the_body_shop_dark_1 = require("./themes/theBodyShop/the-body-shop-dark");

exports.default = {
  avon: {
    dark: avon_dark_1.avonDark,
    light: avon_light_1.avonLight
  },
  natura: {
    dark: natura_dark_1.naturaDark,
    light: natura_light_1.naturaLight
  },
  theBodyShop: {
    dark: the_body_shop_dark_1.theBodyShopDark,
    light: the_body_shop_light_1.theBodyShopLight
  }
};